import React from 'react';

const ConclusaoCanonica = ({ vm }) => {
  const buildConclusao = (vm) => {
    const faixa = vm.indices.faixa;         // Ex.: "Amarelo"
    const nivel = vm.indices.nivelIM;       // Ex.: "Defensivo"
    const pp = vm.proximosPassos;           // tem titulo + bullets
    const primeira = pp.bullets?.[0];
    const rotulo = pp.titulo;               // Ex.: "Plano de melhoria"

    return `A organização está em ${faixa.toLowerCase()} quanto à exposição e no nível ${nivel.toLowerCase()} de maturidade. Recomendamos iniciar ${rotulo.toLowerCase()}, priorizando: ${primeira}`;
  };

  const styles = {
    container: {
      marginBottom: '32px',
      padding: '24px',
      background: 'linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%)',
      border: '1px solid #0ea5e9',
      borderRadius: '12px'
    },
    title: {
      fontSize: '1.125rem',
      fontWeight: '600',
      color: '#0c4a6e',
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    icon: {
      fontSize: '1.25rem'
    },
    text: {
      fontSize: '1rem',
      color: '#075985',
      lineHeight: '1.6',
      margin: 0
    }
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>
        <span style={styles.icon}>📋</span>
        Conclusão
      </h3>
      <p style={styles.text}>
        {buildConclusao(vm)}
      </p>
    </div>
  );
};

export default ConclusaoCanonica;